/**
 * Connects the organization scope to the running app.
 *
 * Imported for its side effect from `main.tsx`, before React renders, so the
 * very first organization selection — which happens as soon as the user-data
 * fetch resolves — is already being observed. Installing this from a component
 * effect instead would leave a window in which a switch went unnoticed, and
 * would tie the whole app's tenant isolation to one component staying mounted.
 *
 * Every store's own teardown is registered inside that store's module (see
 * `@/lib/org-scope`), so adding a store cannot silently opt out of isolation.
 * This file only supplies the two things a store cannot: where the active
 * organization comes from, and which query cache to evict.
 */

import { getQueryClient } from '@/dataProvider/reactQuery/context';
import { installOrgScope } from '@/lib/org-scope/bridge';

installOrgScope(getQueryClient());
